import { BillingMode, InvoiceStatus, InvoiceType } from '../../../../../../services/exports/Constants';

export default {
  title: 'Facturas',
  form: {
    title: 'Solicitar nuevo pago',
    company: {
      label: 'Restaurante',
    },
    billing_mode: {
      label: 'Fuente de facturación',
    },
    billing_anchor: {
      label: 'Iniciar facturación en',
    },
    items: {
      label: 'Artículos',
    },
    name: {
      label: 'Nombre',
      placeholder: '1000x Flyers',
    },
    net_amount: {
      label: 'Importe (NETO)',
      tax_breakdown: '+{{tax}} IVA = {{total}}',
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurante',
    name: 'Nombre/Número',
    billing_mode: 'Fuente de facturación',
    type: 'Tipo',
    status: 'Estado',
    amount: 'Importe (bruto)',
    created_at: 'Creado',
    billing_anchor: 'Facturación desde',
    invoice: 'Factura',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Método de pago',
    [BillingMode.InternalInvoicing]: 'Ventas',
  },
  types: {
    [InvoiceType.Manual]: 'Manual',
    [InvoiceType.SetupFee]: 'Tarifa de configuración',
    [InvoiceType.Subscription]: 'Suscripción',
    [InvoiceType.SubscriptionBridge]: 'Suscripción (prorrateada hasta el día 5)',
    [InvoiceType.SubscriptionProration]: 'Suscripción (mejora prorrateada)',
    [InvoiceType.DisputeFee]: 'Tarifa por disputa',
    [InvoiceType.ChargebackReversalFee]: 'Tarifa por reversión de contracargo',
    [InvoiceType.SecondChargebackFee]: 'Tarifa por segundo contracargo',
    [InvoiceType.RefundFailureFee]: 'Tarifa por reembolso fallido',
    [InvoiceType.BillingCycle]: 'Ciclo de facturación',
    [InvoiceType.NegativeBalanceCompensation]: 'Compensación de saldo negativo',
  },
  statuses: {
    [InvoiceStatus.Pending]: 'Pendiente',
    [InvoiceStatus.Processing]: 'Procesando',
    [InvoiceStatus.Paid]: 'Pagado',
    [InvoiceStatus.PartiallyRefunded]: 'Parcialmente reembolsado',
    [InvoiceStatus.Refunded]: 'Reembolsado',
    [InvoiceStatus.Failed]: 'Fallido',
  },
  modals: {
    invoice_creation_confirmation: {
      title: '¿Seguro que deseas crear una factura de {{amount}} NETO para {{company}} desde {{billingMode}}?',
    },
    invoice_recharge_confirmation: {
      title: '¿Estás seguro?',
      description:
        '<strong>{{company}}</strong> será recargado <strong>{{amount}} bruto + penalización por fallo de pago si aplica</strong> desde el método de pago principal para la factura {{details}}',
      recharge_failed: {
        title: 'Stripe rechazó el pago',
        convert_hint:
          'Puedes cobrar esta factura desde las ventas del restaurante. La factura de Stripe se anulará y el importe pendiente se deducirá de los próximos pagos.',
      },
    },
  },
  buttons: {
    show_transfers: 'Mostrar transferencias',
    hide_transfers: 'Ocultar transferencias',
    create: 'Crear',
    download_pdf: 'Descargar PDF',
    open_payment_page: 'Abrir página de pago',
    open_invoice_page: 'Ver detalles de factura',
    add_item: 'Añadir artículo',
    convert_to_internal_billing: 'Cobrar desde ventas',
    recharge_invoice: 'Reintentar factura',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    failed_to_create_invoice: '¡Error al crear la factura!',
    invoice_got_created: '¡Factura creada!',
    invoice_got_recharged: '¡Factura recargada. El nuevo pago se está procesando!',
    failed_to_recharge_invoice: '¡Error al recargar la factura!',
    invoice_got_converted_to_internal_billing:
      'Factura convertida a facturación por ventas. El importe pendiente se deducirá de los próximos pagos.',
    failed_to_convert_invoice_to_internal_billing: '¡Error al convertir la factura a facturación por ventas!',
  },
};
